import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';

import styles from '../SpendingLimitDrawer.module.css';
import { UnavailableLimit } from './UnavailableLimit';
import {
    TSpendingLimits,
    TSpendingLimitType
} from '../../hooks/useGetSpendingLimits';
import { formatDuration } from '../../spendingLimitCard/components/formatDuration';

export const ValidLimitDrawer = ({
    spendingLimits
}: {
    spendingLimits: TSpendingLimits;
}) => {
    const hasThirtyDaysLimit = Boolean(spendingLimits.limits['THIRTY_DAYS']);

    return (
        <>
            <div className={styles.spendingLimits}>
                {Object.keys(spendingLimits.limits)
                    .filter((spendingLimitKey) => {
                        // Exclude THIRTY_DAYS limit
                        // Same limit as three months
                        return spendingLimitKey !== 'THIRTY_DAYS';
                    })
                    .map((key) => {
                        const spendingLimit =
                            spendingLimits.limits[key as TSpendingLimitType];

                        if (!spendingLimit)
                            return (
                                <UnavailableLimit
                                    sellerProduct={key as TSpendingLimitType}
                                    key={key}
                                />
                            );

                        return (
                            <div key={key}>
                                <div className={styles.loanDuration}>
                                    {formatDuration({
                                        duration:
                                            spendingLimit.duration_in_months,
                                        groupSameLimits: hasThirtyDaysLimit
                                    })}{' '}
                                    purchases
                                </div>
                                <div className={styles.leftToSpend}>
                                    Left to spend:
                                </div>
                                <div className={styles.creditLimitContainer}>
                                    <FormattedCurrency
                                        className={styles.creditLimit}
                                        value={spendingLimit.available_amount}
                                    />
                                </div>

                                <div className={styles.interestRate}>
                                    {(
                                        spendingLimit.interest_rate * 100
                                    ).toFixed(2)}
                                    %/month or interest-free**
                                </div>
                                <div className={styles.maxLimit}>
                                    Limit:{' '}
                                    <FormattedCurrency
                                        value={spendingLimit.max_amount}
                                    />
                                </div>
                            </div>
                        );
                    })}
            </div>
            <div className={styles.footer}>
                <div>
                    *Your spending limits are subject to approval and reassessed
                    every 30 days - if something changes with your business the
                    amounts might change.
                </div>
                <div>**Interest-free is offered by some of our suppliers.</div>
            </div>
        </>
    );
};
